const copy ={
	copy :  function  (source) {
		var sourceCopy = source instanceof Array ? [] : {};
		for (var item in source) {
            sourceCopy[item] = typeof source[item] === 'object' ? copy.copy(source[item]) : source[item];
        }
		return sourceCopy;
	},
}
export default
{
 copy,
}



// WEBPACK FOOTER //
// ./src/app/deep_copy.js